import React from 'react';
import { ReportInfoPanel } from '@shared/components/ReportInfoPanel';
import ReportInfoItem from '@shared/components/ReportInfoPanelItem';

/**
 * @typedef {object} AggregatePerformanceInfoBoxClassificationMetric
 * @property {number} numberOfSites
 * @property {string} [metricCalculationName]
 * @property {string} goodPerformanceIndicator
 */

/**
 * @typedef {object} AggregatePerformanceInfoBoxProps
 * @property {AggregatePerformanceInfoBoxClassificationMetric} classificationMetric
 */

/**
 * @param {AggregatePerformanceInfoBoxProps} props
 */
const AggregatePerformanceInfoBox = props => {
  const { classificationMetric } = props;

  return (
    <ReportInfoPanel>
      <ReportInfoItem label='Number of Sites' value={classificationMetric.numberOfSites} />
      <ReportInfoItem
        label='Metric Calculation'
        value={classificationMetric.metricCalculationName}
      />
      <ReportInfoItem
        label='Indication of Improving'
        value={classificationMetric.goodPerformanceIndicator}
      />
    </ReportInfoPanel>
  );
};

export default AggregatePerformanceInfoBox;
